import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "caresenta_announce_dismissed_v1";
const ALLOWED_PATHS = ["/", "/modules", "/pricing"];

export default function AnnouncementBar() {
  const loc = useLocation();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      setDismissed(stored === "1");
    } catch {
      setDismissed(false);
    }
  }, []);

  const onDismiss = () => {
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch {}
    setDismissed(true);
  };

  if (dismissed) return null;
  if (!ALLOWED_PATHS.includes(loc.pathname)) return null;

  return (
    <div
      className="text-[#F8F7F4] text-sm"
      style={{ background: "#0E8B7E", height: "40px" }}
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0 truncate text-[13px] sm:text-[14px]">
          <span className="hidden sm:inline">CareSenta works alongside Epic, Athena, and Cerner — not instead of them.</span>
          <span className="sm:hidden">Works alongside Epic, Athena & Cerner.</span>
          <Link
            to="/works-with-epic"
            data-testid="announcement-bar-cta"
            className="ml-3 underline underline-offset-4 decoration-[#F8F7F4]/60 hover:decoration-[#F8F7F4] font-medium whitespace-nowrap"
          >
            See how it works →
          </Link>
        </div>
        <button
          onClick={onDismiss}
          aria-label="Dismiss announcement"
          data-testid="announcement-bar-dismiss"
          className="shrink-0 p-1.5 -mr-1.5 hover:bg-white/10 rounded-sm transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
